var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.333h1.333V2H6c-1.243 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443C2 4.136 2 4.757 2 6v4c0 1.242 0 1.864.203 2.354.27.653.79 1.172 1.443 1.443C4.136 14 4.757 14 6 14h4c1.242 0 1.864 0 2.354-.203a2.666 2.666 0 0 0 1.443-1.443C14 11.864 14 11.243 14 10V8.667h-1.333V10c0 .64-.001 1.052-.023 1.368-.02.304-.056.42-.079.476a1.334 1.334 0 0 1-.721.721c-.056.023-.172.059-.476.08-.316.02-.729.022-1.368.022H6c-.64 0-1.052-.001-1.368-.023-.304-.02-.42-.056-.476-.079a1.334 1.334 0 0 1-.721-.721c-.023-.056-.059-.172-.08-.476A22.556 22.556 0 0 1 3.334 10V6c0-.64.001-1.052.023-1.368.02-.304.056-.42.079-.476.135-.326.395-.586.721-.721.056-.023.172-.059.476-.08.316-.02.729-.022 1.368-.022Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 2v1.333h2.388L6.452 8.601l.943.943 5.271-5.271v2.394h1.329V2.002L9.333 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/newTab.c3b274f669b5c7f86ae30c16c059c860.svg";
export { ForwardRef as ReactComponent };